import { QuestionsProps, QuestionProps } from '../typings/register'

//Action Types
export const SET_SIGNUP_QUESTIONS = "setSignupQuestions";
export const RESET_SIGNUP_QUESTIONS = "resetSignupQuestions";

//Action creators
export const setSignupQuestions = (data: QuestionsProps) => ({
    type: SET_SIGNUP_QUESTIONS,
    data
});

export const resetSignupQuestions = () => ({
    type: RESET_SIGNUP_QUESTIONS,
});

const initialState: QuestionsProps = {
    questions: []

    //Reducer
}


export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case SET_SIGNUP_QUESTIONS:

            return { ...state, questions: action.data };
        case RESET_SIGNUP_QUESTIONS:
            return { ...initialState };
        default:
            return state;
    }
}